import type { IntegrityCheckResponse } from "../../api/types";

function fmt(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}

interface IntegrityAlertsProps {
  check: IntegrityCheckResponse;
}

export function IntegrityAlerts({ check }: IntegrityAlertsProps) {
  if (check.status === "passed" || check.status === "running") {
    return null;
  }

  if (check.status === "error") {
    return (
      <div className="card" style={{ background: "var(--orange-bg)", border: "1px solid var(--orange-bd)", color: "var(--orange)", fontSize: "13px", fontWeight: 600 }}>
        Integrity check encountered an error. Prices may have drifted.
      </div>
    );
  }

  return (
    <div className="card" style={{ background: "var(--orange-bg)", border: "1px solid var(--orange-bd)" }}>
      <div style={{ fontSize: "13px", fontWeight: 700, color: "var(--orange)", marginBottom: "8px" }}>
        Price drift detected — {check.drifted_items.length} item{check.drifted_items.length !== 1 ? "s" : ""} changed outside this app
      </div>
      <div style={{ maxHeight: "120px", overflowY: "auto" }}>
        {check.drifted_items.map((d) => (
          <div key={d.variation_id} style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", padding: "4px 0", borderBottom: "1px solid var(--orange-bd)" }}>
            <span style={{ fontFamily: "var(--mono)", color: "var(--ink2)" }}>{d.variation_id.slice(0, 12)}...</span>
            <span style={{ fontFamily: "var(--mono)" }}>Expected {fmt(d.expected_cents)}, got {fmt(d.actual_cents)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
